import { Link } from 'react-router-dom';

export default function CreationSiteInternetParis() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-teal-500 to-orange-500 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xl">DC</span>
            </div>
            <span className="text-xl font-bold text-gray-900">DigiCreate</span>
          </Link>
          <a href="tel:+33123456789" className="bg-teal-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-600 transition-all hover:scale-105 flex items-center gap-2 whitespace-nowrap">
            <i className="ri-phone-line text-lg"></i>
            Appeler
          </a>
        </div>
      </header>

      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
            Création de Site Internet à Paris
          </h1>
          <p className="text-xl text-gray-600 mb-8 leading-relaxed">
            Agence spécialisée en <strong>création de site web professionnel</strong> et <strong>webdesign responsive</strong> à Paris. Nous concevons des sites internet sur-mesure qui convertissent vos visiteurs en clients.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20la%20création%20de%20site%20internet" className="bg-teal-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:bg-teal-600 transition-all hover:scale-105 whitespace-nowrap">
              Demander un Devis Gratuit
            </a>
            <Link to="/" className="bg-gray-100 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-200 transition-all whitespace-nowrap">
              Voir nos Réalisations
            </Link>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Nos Services de Création Web à Paris</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            De la <strong>conception de site vitrine</strong> à la <strong>création de boutique e-commerce</strong>, nous maîtrisons tous les aspects du développement web moderne.
          </p>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-window-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Site Vitrine Professionnel</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Création de <strong>site internet responsive</strong> pour présenter votre activité avec un design moderne et une navigation intuitive optimisée pour le référencement naturel.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Design sur-mesure et responsive</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Optimisation SEO Paris</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-teal-500 mt-1"></i>
                  <span>Performance et rapidité</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-orange-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-shopping-cart-line text-3xl text-orange-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Boutique E-commerce</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Développement de <strong>site e-commerce professionnel</strong> avec Shopify ou WooCommerce pour vendre vos produits en ligne avec un tunnel de conversion optimisé.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Paiement sécurisé intégré</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Gestion des stocks</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-1"></i>
                  <span>Interface d'administration</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-all">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-6">
                <i className="ri-smartphone-line text-3xl text-purple-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Application Web Mobile</h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                Création d'<strong>application web progressive</strong> (PWA) pour offrir une expérience mobile native à vos utilisateurs avec des performances optimales.
              </p>
              <ul className="space-y-2 text-gray-600">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Expérience mobile fluide</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Fonctionnement hors-ligne</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-purple-500 mt-1"></i>
                  <span>Installation sur écran d'accueil</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl font-black text-gray-900 mb-4 text-center">Notre Processus de Création</h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-3xl mx-auto">
            Une méthodologie éprouvée pour garantir le succès de votre projet de <strong>création de site internet à Paris</strong>.
          </p>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              { icon: 'ri-lightbulb-line', title: 'Analyse', desc: 'Étude de vos besoins et de votre cible' },
              { icon: 'ri-pencil-ruler-2-line', title: 'Design', desc: 'Maquettes et charte graphique sur-mesure' },
              { icon: 'ri-code-s-slash-line', title: 'Développement', desc: 'Intégration pixel-perfect et responsive' },
              { icon: 'ri-rocket-line', title: 'Lancement', desc: 'Mise en ligne et formation' }
            ].map((step, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-orange-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
                  <i className={`${step.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-sm font-bold text-teal-500 mb-2">Étape {index + 1}</div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-teal-500 to-orange-500">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl md:text-5xl font-black mb-6">Prêt à Lancer Votre Projet Web ?</h2>
          <p className="text-xl mb-8 opacity-95">
            Contactez notre agence de création digitale à Paris pour un devis gratuit et personnalisé.
          </p>
          <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20un%20devis%20pour%20la%20création%20de%20mon%20site%20internet" className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-all hover:scale-105 whitespace-nowrap">
            Demander un Devis Gratuit
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-gray-400 mb-4">© 2025 DigiCreate - Agence de Création Digitale à Paris</p>
          <div className="flex justify-center gap-6">
            <Link to="/" className="text-gray-400 hover:text-white transition-colors">Accueil</Link>
            <a href="mailto:contact@digicreate.fr" className="text-gray-400 hover:text-white transition-colors">Contact</a>
          </div>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a href="https://wa.me/33123456789?text=Bonjour,%20je%20souhaite%20obtenir%20des%20informations%20sur%20vos%20services%20digitaux" className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-all animate-bounce" aria-label="Contacter sur WhatsApp">
        <i className="ri-whatsapp-line text-3xl text-white"></i>
        <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></span>
      </a>
    </div>
  );
}
